import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { getThemeColors } from '../styles/theme';
import WhenconnectLayout from './WhenconnectLayout';
import WhenconnectDashboard from './WhenconnectDashboard';
import WhenconnectContact from './WhenconnectContact';
import WhenconnectErvaringen from './WhenconnectErvaringen';

function getIsLight() {
  const saved = localStorage.getItem('whenconnect_theme');
  if (saved) return saved === 'light';
  return window.matchMedia('(prefers-color-scheme: light)').matches;
}

function buildTheme(isLight) {
  const mode = isLight ? 'light' : 'dark';
  return { mode, colors: getThemeColors(mode) };
}

const SESSION_KEY = 'whenconnect_session';
const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

export function getWhenconnectSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session?.session_expires_at || Date.now() > session.session_expires_at) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function saveWhenconnectSession(userData) {
  const session = {
    ...userData,
    session_expires_at: Date.now() + THIRTY_DAYS,
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearWhenconnectSession() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem('webvonk_superadmin');
}

export default function WhenconnectApp() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  const [isLight, setIsLight] = useState(getIsLight);

  useEffect(() => {
    const session = getWhenconnectSession();
    if (!session) { setChecked(true); return; }
    setUser(session);
    setChecked(true);
  }, []);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: light)');
    const h = (e) => { if (!localStorage.getItem('whenconnect_theme')) setIsLight(e.matches); };
    mq.addEventListener('change', h);
    return () => mq.removeEventListener('change', h);
  }, []);

  const handleLogout = () => {
    clearWhenconnectSession();
    setUser(null);
    navigate('/', { replace: true });
  };

  if (!checked) return null;

  return (
    <ThemeProvider theme={buildTheme(isLight)}>
    <WhenconnectLayout onLogout={handleLogout}>
      <Routes>
        <Route path="dashboard" element={user ? <WhenconnectDashboard user={user} /> : <Navigate to="/" replace />} />
        <Route path="contactinzendingen" element={user ? <WhenconnectContact /> : <Navigate to="/" replace />} />
        <Route path="ervaringen" element={user ? <WhenconnectErvaringen /> : <Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to={user ? '/Whenconnect/dashboard' : '/'} replace />} />
      </Routes>
    </WhenconnectLayout>
    </ThemeProvider>
  );
}
